import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-layers",
  "use": "icon-layers-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" class=\"feather feather-layers\" id=\"icon-layers\"><polygon points=\"12 2 2 7 12 12 22 7 12 2\" /><polyline points=\"2 17 12 22 22 17\" /><polyline points=\"2 12 12 17 22 12\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol